// Popular locations for Google Trends
export const TREND_LOCATIONS = [
    { code: '2840', name: 'United States', flag: '🇺🇸' },
    { code: '2826', name: 'United Kingdom', flag: '🇬🇧' },
    { code: '2124', name: 'Canada', flag: '🇨🇦' },
    { code: '2036', name: 'Australia', flag: '🇦🇺' },
    { code: '2356', name: 'India', flag: '🇮🇳' },
    { code: '2276', name: 'Germany', flag: '🇩🇪' },
    { code: '2250', name: 'France', flag: '🇫🇷' },
    { code: '2724', name: 'Spain', flag: '🇪🇸' },
    { code: '2380', name: 'Italy', flag: '🇮🇹' },
    { code: '2392', name: 'Japan', flag: '🇯🇵' },
    { code: '2410', name: 'South Korea', flag: '🇰🇷' },
    { code: '2076', name: 'Brazil', flag: '🇧🇷' },
    { code: '2484', name: 'Mexico', flag: '🇲🇽' },
    { code: '2528', name: 'Netherlands', flag: '🇳🇱' },
    { code: '2752', name: 'Sweden', flag: '🇸🇪' },
];

export const DEFAULT_LOCATION = '2840'; // United States
